// src/utils/platformFromChannel.js
const MAP = {
  '인스타그램': 'INSTAGRAM',
  '인스타 게시물': 'INSTAGRAM',
  '인스타 스토리': 'INSTAGRAM_STORIES',
  '카카오톡': 'KAKAO',
  "MMS(문자)": "MMS",
  '네이버 밴드': 'BAND',
  'X(트위터)': 'X'
};

const MAP_NUM = {
  '1': 'KAKAO',
  '2': 'INSTAGRAM_STORIES',
  '3': 'INSTAGRAM',
  '5': 'MMS',
  '6': 'BAND',
  '7': 'X',
};

export default function platformFromChannel(ch) {
  const key = (ch ?? '').toString().trim();   // 숫자/문자 모두 처리
  return MAP[key] || MAP_NUM[key] || 'system';
}
